import React, { useEffect, useState } from "react";
import "../../../assets/scss/home.scss";
import "../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import StudyLogsTable from "../../../components/tables/studyLogsTable";
import Repository from "../../../configs/axios/repository";

const QuizLog = ({}) => {
    const [loadingData, setLoadingData] = useState(false);
    const [count, setCount] = useState(0);
    const [data, setData] = useState([]);
    const [showData, setShowData] = useState(10);
    const [skipData, setSkipData] = useState(0);

    const findUserLogs = async () => {
        let array = [];
        const result = await Repository.findByEndPoint(
            `api/users/findUserLogs`
        );

        if (result.status === 200 || result.status === 201) {
            let dataFlash = result.data.data?.flashcard_id.map((val) => {
                return {
                    id: val.flashcard_id,
                    note_name: val.note_id.title,
                    note_description: val.note_id.description,
                    name: val.flashcard_name,
                    content: val.flashcard_content,
                    type: val.flashcard_type,
                    notes: val.notes,
                    icon: val.icon,
                    no_of_questions: val.no_of_questions,
                    score: val.score,
                    result: val.result_test_flashcard,
                    note_id: val.note_id.note_id,
                    created_at: val.created_at,
                    updated_at: val.updated_at,
                };
            });
            let dataTest;

            if (result.data?.data?.test_id != undefined) {
                dataTest = result.data.data?.test_id.map((val) => {
                    return {
                        id: val.test_id,
                        note_name: val.note_id.title,
                        note_description: val.note_id.description,
                        name: val.test_name,
                        content: val.test_content,
                        type: val.test_type,
                        notes: val.test_prompt,
                        icon: val.icon,
                        result: val.result_test_flashcard,
                        no_of_questions: val.no_of_questions,
                        score: val.score,
                        note_id: val.note_id.note_id,
                        created_at: val.created_at,
                        updated_at: val.updated_at,
                    };
                });
            } else {
                dataTest = [];
            }
            if (dataFlash != undefined) {
                array.push(...dataFlash, ...dataTest);
            }
        }
        setCount(array.length);
        array.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));

        setData(array);
        setLoadingData(true);
    };

    useEffect(async () => {
        findUserLogs();
    }, [showData, skipData]);

    return loadingData ? (
        <div className="testBodyDiv homeSection">
            <div className="d-flex justify-content-between">
                <div className="clidrenDivCompakt testH1">
                    <div className="mt-4 studyLogs">
                        <h1>Your Quiz Logs</h1>
                    </div>
                </div>
            </div>

            {data.length > 0 ? (
                <StudyLogsTable
                    data={data}
                    setLoadingData={setLoadingData}
                    loadingData={loadingData}
                />
            ) : (
                <div>
                    <h5 className="nodata">
                        Your quiz results will be displayed here once you have
                        completed at least one quiz.
                    </h5>
                </div>
            )}
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default QuizLog;
